import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ProfessionalFiguresForm from './ProfessionalFiguresForm'

const ProfessionalFiguresCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <ProfessionalFiguresForm />
      </Create>
    </SectionWrapper>
  )
}

export default ProfessionalFiguresCreate
